import React, { useEffect, useRef } from "react";
import Webcam from "react-webcam";

const videoConstraints = {
  width: 280,
  height: 280,
  facingMode: "environment",
};

const WebcamCapture = ({ onScan }) => {
  const webcamRef = useRef(null);

  useEffect(() => {
    const timer = setInterval(() => {
      capture();
    }, 500);
    return () => clearInterval(timer);
  }, []);

  const capture = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    onScan(imageSrc);
  };

  return (
    <Webcam
      audio={false}
      ref={webcamRef}
      screenshotFormat="image/jpeg"
      videoConstraints={videoConstraints}
      onClick={() => capture()}
    />
  );
};

export default WebcamCapture;
